import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-collections-dialog',
  templateUrl: './collections-dialog.component.html',
  styleUrls: ['./collections-dialog.component.scss']
})
export class CollectionsDialogComponent implements OnInit {

  code;
  constructor() { }

  ngOnInit(): void {
  }
  openSelf(){
  }
  validateCode(){
    if(this.code == "1234"){
      console.log("AASDAS")
      localStorage.setItem('isConfirmed', "1");
      window.location.reload();
    }
  }
}
